import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as systemConfigActions from '../systemconfig/redux/actions';
import { Input, DatePicker,Select } from 'antd';
import moment from "moment"
import { Page, Crud } from '../../components';

const { CrudTable, CrudForm, CrudFilter, CrudButtons } = Crud;
const Option = Select.Option;
export class Frui_pfbzPage extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
 state = {
    id: ''
 }
  componentDidMount() {
    const { frui_pfbzPage, currentFrui_pfbz } = this.props.user;
    const { getAllQppzList } = this.props.actions
    const { getDictionariesList } = this.props.systemConfigActions;
    getDictionariesList();
    getAllQppzList()
    this.fetchList(frui_pfbzPage);
  }

  fetchList = (page, values) => {
    const { getFrui_pfbzList } = this.props.actions;
    let params = Object.assign({}, { page: page,size:10 }, values);
    getFrui_pfbzList(params);
  };

  getDataSource() {
    const { user } = this.props;
    const { frui_pfbzById, frui_pfbzList } = user;
    if (!frui_pfbzList) return [];
    return frui_pfbzList.map(id => frui_pfbzById[id]);
  }
//  类别
  getcategory = () => {
     const { getgetDictionariesMap } = this.props.systemconfig;
    let arr = getgetDictionariesMap[10];
    if(arr) {
     return  (arr.dictDetails).map(item => <Option key={item.value}>{item.value}</Option>)
    }
  }

  get listProps() {
    const { user, actions } = this.props;
    const { getFrui_pfbzListPending, frui_pfbzTotal, frui_pfbzPage } = user;
    const { deleteFrui_pfbz, chooseCurrentFrui_pfbz, frui_pfbzModalChange } = actions;
    return {
      dataSource: this.getDataSource(),
      loading: getFrui_pfbzListPending,
      scroll: { x: 1300 },
      columns: [
        // 授权编号+主键id
        {
          title: '系统编号',
          dataIndex: 'bm',
          key: 'bm',
          width: 180,
        },
        {
          title: '标准编号',
          dataIndex: 'bh',
          key: 'bh',
          width: 180,
        },

        {
          title: '气瓶品种',
          dataIndex: 'gcId',
          key: 'gcId',
          width: 180,
        },
        {
          title: '类别',
          dataIndex: 'lb',
          key: 'lb',
          width: 180,
        },
        {
          title: '修改人',
          dataIndex: 'modifyBy',
          key: 'modifyBy',
          width: 180,
        },
        {
          title: '标准名称',
          dataIndex: 'name',
          key: 'name',
          width: 180,
        },
        {
          title: '气瓶品种编号',
          dataIndex: 'qpCode',
          key: 'qpCode',
          width: 180,
        },
        {
          title: '气瓶品种名称',
          dataIndex: 'qpName',
          key: 'qpName',
          width: 180,
        },
        {
          title: '标准有效期至',
          dataIndex: 'yxq',
          key: 'yxq',
          width: 180,
        },
      ],
      pagination: {
        total: frui_pfbzTotal,
        current: frui_pfbzPage,
        onChange: page => {
          this.fetchList(page);
        },
      },
      op: [
        {
          key: 1,
          name: '编辑',
          buttonProps: {
            icon: 'edit',
            type: 'primary',
          },
        },
        {
          key: 3,
          name: '删除',
          buttonProps: {
            icon: 'delete',
            type: 'danger',
          },
          needConfirm: true,
          confirmTitle: '确认删除',
        },
      ],
      handleMenuClick: (record, item) => {
        if (item.key == 1) {
          chooseCurrentFrui_pfbz(record);
          frui_pfbzModalChange(true, 'updata');
        } else if (item.key == 3) {
          deleteFrui_pfbz(record.id).then(data => {
            this.fetchList();
          });
        }
      },
    };
  }
// 气瓶品种
gethandleQpCode = () => {
  const {getAllQppzListId,getAllQppzList} = this.props.user
 return getAllQppzList.map(id => getAllQppzListId[id]).map(item => (
     <Option key={item.qpCode} >{`${item.qpName} ${item.qpCode}`}</Option>
  ))
} 
   //气瓶品种回调
  handleChangeQpId = res => {
     const { getAllQppzListId,getAllQppzList } = this.props.user;
     let List = []
     List.push(res)
     let object = {}
    //  变成 map 找到对应的对象
     getAllQppzList.map(id => getAllQppzListId[id]).map(item => object[item.qpCode] = item)
     console.log(object)
     console.log(List)
     List.map(id => object[id]).map(item => (
       this.setState({
         id:item.id
       })
     ))
  };

  get modalProps() {
    const { user, actions } = this.props;
    const {
      currentFrui_pfbz,
      frui_pfbzModalVisible,
      frui_pfbzPage,
      frui_pfbzModalType,
      submitFrui_pfbzPending,
    } = user;

    const { frui_pfbzModalChange, submitFrui_pfbz } = actions;
    const editItem = frui_pfbzModalType === 'create' ? {} : currentFrui_pfbz;
    return {
      item: frui_pfbzModalType === 'create' ? {} : currentFrui_pfbz,
      visible: frui_pfbzModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitFrui_pfbzPending,
      title: `${frui_pfbzModalType === 'create' ? `创建` : `更新`}`,
      centered: true,
      elements: [
        {
          key: 'bm',
          label: '系统编号',
          initialValue: editItem.bm,
          widget: Input,
          disabled:true
        },
        {
          key: 'name',
          label: '标准名称',
          initialValue: editItem.name,
          widget: Input,
          required: true,
        },
        {
          key: 'lb',
          label: '类别',
          initialValue: `${editItem.lb || ""}`,
          widget: Select,
          children:this.getcategory(),
          required: true,
        },
        {
          key: 'bh',
          label: '标准编号',
          initialValue: editItem.bh,
          widget: Input,
          required: true,
        },
        {
          key: 'days',
          label: '有效期预警',
          initialValue: editItem.days,
          widget: Input,
        },
      
          {
          key: 'qpcode',
          label: '气瓶品种',
          initialValue: editItem.qpCode,
          widget: Select,
          children:this.gethandleQpCode(),
            widgetProps: {
            onChange: res => this.handleChangeQpId(res),
          },
          
        },
          {
          key: 'gcId',
          label: '气瓶品种id',
          initialValue: this.state.id || editItem.gcId,
          widget: Input,
          disabled:true,
        },
        {
          key: 'yxq',
          label: '标准有效期至',
          initialValue: moment(editItem.yxq),
          widget: DatePicker,
        },
        {
          key: 'remark',
          label: '备注',
          initialValue: editItem.remark,
          widget: Input,
        },
      ],
      onOk: data => {
        let params = {
          bm:data.bm,
          name:data.name,
          lb:data.lb,
          bh:data.bh,
          days:data.days,
          qpcode:data.qpcode,
          gcId:data.gcId || data.gcId,
          yxq:data.yxq.format('YYYY-MM-DD'),
          remark:data.remark
        }
        submitFrui_pfbz(params).then(data => {
          frui_pfbzModalChange(false, 'create');
          this.fetchList(frui_pfbzPage);
          this.setState({
            id:''
          })
        });
      },
      onCancel:() =>  {
        frui_pfbzModalChange(false, 'create');
        this.fetchList(frui_pfbzPage);
        this.setState({
            id:''
          })
      },
    };
  }

  get buttonProps() {
    const { actions, user } = this.props;
    const { currentFrui_pfbz, frui_pfbzPage } = user;
    const { frui_pfbzModalChange } = actions;

    return {
      buttons: [
        {
          name: '新增',
          buttonProps: {
            type: 'primary',
            icon: 'plus',
          },
          onClick: () => {
            frui_pfbzModalChange(true, 'create');
          },
        },
      ],
    };
  }

  render() {
    return (
      <Page inner>
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    user: state.user,
    systemconfig: state.systemconfig,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    systemConfigActions: bindActionCreators({ ...systemConfigActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Frui_pfbzPage);



// WEBPACK FOOTER //
// ./src/features/user/Frui_pfbzPage.js